import { UserCtx } from "@budibase/types"
import { Next } from "koa"
import { context } from "@budibase/backend-core"
import { isExpandedPublicApiEnabled } from "../features"

export function buildImportFn(importFn: (ctx: UserCtx) => Promise<any>) {
  return async (ctx: UserCtx, next: Next) => {
    if (!(await isExpandedPublicApiEnabled())) {
      ctx.throw(403, "Endpoint unavailable, license required.")
    }
    if (!ctx.request.files?.appExport) {
      ctx.throw(400, "Must provide app export file for import.")
    }
    await context.doInAppContext(ctx.params.appId, async () => {
      await importFn(ctx)
      ctx.body = undefined
      ctx.status = 204
      await next()
    })
  }
}

export function buildExportFn(exportFn: (ctx: UserCtx) => Promise<any>) {
  return async (ctx: UserCtx, next: Next) => {
    if (!(await isExpandedPublicApiEnabled())) {
      ctx.throw(403, "Endpoint unavailable, license required.")
    }
    const { encryptPassword, excludeRows } = ctx.request.body
    await context.doInAppContext(ctx.params.appId, async () => {
      // make sure no other inputs
      ctx.request.body = {
        encryptPassword,
        excludeRows,
      }
      ctx.query.appId = ctx.params.appId
      await exportFn(ctx)
      await next()
    })
  }
}
